import * as React from "react";
import {Component} from "react";
import styles from "../../styles/flyouts/expansion_joints/Properties.scss";
import * as _ from "lodash";
import {withRouter} from "react-router";
import autobind from "autobind-decorator";
import {__, validateForm} from "../../core/utils";
import {setNotification} from "../../redux/actions/general/notification";
import {listExpansionJoints, updateExpansionJoint} from "../../redux/actions/table/expansion_joints";
import EditExpansionJointForm from "../../forms/expansion_joints/EditExpansionJointForm";

@withRouter
class Properties extends Component {
    @autobind
    _handleSubmit(formData) {
        return validateForm(
            updateExpansionJoint(formData.id, _.omit(formData, ['id'])).then(() => {
                listExpansionJoints(this.props.match.params.stage);

                this.props.readAction(formData.id);

                setNotification(__('expansion-joints.flyout.notification.saved'));
            })
        );
    }

    render() {
        const {data} = this.props;

        return (
            <div className={styles.scroller}>
                <EditExpansionJointForm
                    onSubmit={this._handleSubmit}
                    data={data}
                    initialValues={{
                        ..._.pick(data, ['id', 'title', 'description', 'area']),
                    }}
                />
            </div>
        );
    }
}

export default Properties;
